import {
  BASE_ARTICLE_45,
  BASE_MANAGEMENT_AGREEMENT,
} from 'src/app/_services/constants/base-contracts-info';
import { ContractToSignInfo } from 'src/app/_services/types/contract-template.types';
import { SharedFunnelDatalayerEvent } from 'src/app/_services/types/datalayer.types';
import { Step } from 'src/app/_services/types/step.type';
import { ContractType } from 'src/app/enums/contract-type.enum';
import { InsuranceTypeEnum } from 'src/app/enums/insurance-type.enum';
import { LinearStepperElement } from 'src/app/ui-kit/components/linear-stepper/linear-stepper.component';

import { BUSINESS_INSURANCE_BASE } from '../company-insurance-constants';

export const BUSINESS_VEHICLE_INSURANCE_BASE = 'vehicule';

export const BUSINESS_VEHICLE_FORM_BASE = `${BUSINESS_INSURANCE_BASE}/${BUSINESS_VEHICLE_INSURANCE_BASE}`;

export const CONTRACTS_TO_SIGN: ContractToSignInfo[] = [
  {
    ...BASE_ARTICLE_45,
    name: 'Article 45 véhicule entreprise',
    type: ContractType.ARTICLE_45,
    insuranceType: InsuranceTypeEnum.BUSINESS_MOTOR_VEHICLE,
  },
  {
    ...BASE_MANAGEMENT_AGREEMENT,
    name: 'Mandat gestion véhicule entreprise',
    type: ContractType.MANAGEMENT_AGREEMENT,
    insuranceType: InsuranceTypeEnum.BUSINESS_MOTOR_VEHICLE,
  },
];

export const BUSINESS_VEHICLE_FUNNEL_EVENT_BASE: SharedFunnelDatalayerEvent = {
  event: 'Market_Vehicule entreprise',
  product_category: 'Vehicule entreprise',
  product_name: 'Market',
  funnel_complete: false,
};

export const BUSINESS_VEHICLE_STEPS: {
  MAIN_FORM: Step;
  SECOND_FORM: Step;
  OFFERS: Step;
  LOGIN: Step;
  REGISTER: Step;
  SIGNATURE: Step;
  END: Step;
} = {
  MAIN_FORM: {
    step: [1, 1],
    url: 'preneur-assurance',
    datalayerEvent: {
      ...BUSINESS_VEHICLE_FUNNEL_EVENT_BASE,
      funnel_stage: 1,
      stage_name: 'Preneur assurance',
    },
  },
  SECOND_FORM: {
    step: [3, 1],
    url: 'informations',
    datalayerEvent: {
      ...BUSINESS_VEHICLE_FUNNEL_EVENT_BASE,
      funnel_stage: 2,
      stage_name: 'Informations',
    },
  },
  OFFERS: {
    step: [4, 1],
    url: 'offre',
    datalayerEvent: {
      ...BUSINESS_VEHICLE_FUNNEL_EVENT_BASE,
      funnel_stage: 3,
      stage_name: 'Offre',
    },
  },
  LOGIN: {
    step: [5, 1],
    url: 'connexion',
    datalayerEvent: {
      ...BUSINESS_VEHICLE_FUNNEL_EVENT_BASE,
      funnel_stage: 3,
      stage_name: 'Connexion',
    },
  },
  REGISTER: {
    step: [5, 1],
    url: 'inscription',
    datalayerEvent: {
      ...BUSINESS_VEHICLE_FUNNEL_EVENT_BASE,
      funnel_stage: 4,
      stage_name: 'Inscription',
    },
  },
  SIGNATURE: {
    step: [6, 1],
    url: 'signature',
    datalayerEvent: {
      ...BUSINESS_VEHICLE_FUNNEL_EVENT_BASE,
      funnel_stage: 5,
      stage_name: 'Signatures',
    },
  },
  END: {
    step: [7, 1],
    url: 'fin',
    datalayerEvent: {
      ...BUSINESS_VEHICLE_FUNNEL_EVENT_BASE,
      funnel_stage: 6,
      stage_name: 'Fin',
      funnel_complete: true,
    },
  },
};

export const BUSINESS_VEHICLE_STEPS_NAMES: LinearStepperElement[] = [
  {
    title: $localize`Preneur d'assurance`,
  },
  {
    title: $localize`Informations`,
  },
  {
    title: $localize`Franchise et couvertures`,
  },
  {
    title: $localize`Offre`,
  },
  {
    title: $localize`Compte`,
  },
  {
    title: $localize`Signature de contrat`,
  },
  {
    title: $localize`Fin`,
  },
];
